(function () {

  /* ─────────────────────────────────────────
   * 1. 필수 필드 유효성 체크
   * ───────────────────────────────────────── */
  function isFormValid(modalBody) {
    if (!modalBody) return false;

    // 별점
    const scoreEl = modalBody.querySelector('[data-score]');
    const starFilled = modalBody.querySelector(
      '.yotpo-star-rating-icons-wrapper .yotpo-icon-star[class*="filled"], ' +
      '.yotpo-star-rating-icons-wrapper [class*="star"][class*="selected"], ' +
      '.yotpo-star-rating-icons-wrapper input[type="radio"]:checked'
    );
    if (!starFilled && !(scoreEl && parseInt(scoreEl.dataset.score) > 0)) return false;

    // 리뷰 제목
    const headline = modalBody.querySelector(
      'input[id*="headline"], input[name*="headline"], .yotpo-new-review-headline input'
    );
    if (headline && !headline.value.trim()) return false;

    // 리뷰 내용
    const content = modalBody.querySelector(
      'textarea[id*="body"], textarea[name*="body"], .yotpo-new-review-content textarea'
    );
    if (content && !content.value.trim()) return false;

    // 이름
    const name = modalBody.querySelector(
      'input[id*="name"], input[name*="name"], .yotpo-input-name'
    );
    if (name && !name.value.trim()) return false;

    // 이메일
    const email = modalBody.querySelector(
      'input[id*="email"], input[name*="email"], .yotpo-input-email'
    );
    if (email) {
      const val = email.value.trim();
      if (!val || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) return false;
    }

    // ── custom questions ──────────────────────────
    const fieldsets = modalBody.querySelectorAll(
      '.yotpo-custom-questions-container fieldset.yotpo-form-custom-input-question'
    );

    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend');
      if (!legend) continue;

      const legendText = legend.textContent || '';
      if (!legendText.includes('*')) continue;

      const selected = fieldset.querySelector(
        'button.yotpo-custom-questions-option[aria-pressed="true"]'
      );
      if (!selected) return false;
    }

    return true;
  }

  /* ─────────────────────────────────────────
   * 2. 버튼 disabled 상태 적용
   * ───────────────────────────────────────── */
  function applySubmitButtonState() {
    const modalBody = document.querySelector(
      '#newReviewFormModal .yotpo-new-review-modal-body, #newReviewFormModal form'
    );
    const submitBtn = document.querySelector(
      '#newReviewFormModal .yotpo-new-review-submit, ' +
      '#newReviewFormModal button[class*="new-review-submit"]'
    );
    if (!submitBtn) return;

    const valid = isFormValid(modalBody);
    const isDisabled = submitBtn.hasAttribute('disabled');
    if (valid === !isDisabled) return;

    if (window.__sgYotpoGridObserver) window.__sgYotpoGridObserver.disconnect();

    if (valid) {
      submitBtn.removeAttribute('disabled');
      submitBtn.style.removeProperty('opacity');
      submitBtn.style.removeProperty('cursor');
      submitBtn.style.removeProperty('pointer-events');
      submitBtn.style.setProperty('background-color', '#0D0C34', 'important');
    } else {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.style.setProperty('opacity', '0.4', 'important');
      submitBtn.style.setProperty('cursor', 'not-allowed', 'important');
      submitBtn.style.setProperty('pointer-events', 'auto', 'important');
    }

    if (window.__sgYotpoGridObserver) {
      window.__sgYotpoGridObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  /* ─────────────────────────────────────────
   * 3. "* required fields" 재배치
   * ───────────────────────────────────────── */
  function relocateRequiredFieldsNotice(modalBody) {
    if (!modalBody) return;

    const footer = document.querySelector('#newReviewFormModal .form-footer');
    if (!footer) return;

    const notice = Array.from(footer.querySelectorAll('p')).find((p) =>
      /required fields/i.test(p.textContent || '')
    );
    if (!notice) return;

    if (notice.parentElement === modalBody) return;

    notice.classList.add('sg-required-fields-notice');
    modalBody.insertBefore(notice, modalBody.firstChild);
    notice.style.setProperty('grid-area', 'required-fields', 'important');
  }

  /* ─────────────────────────────────────────
   * 4. Grid 순서 강제 고정
   * ───────────────────────────────────────── */
  function applyYotpoGridFix() {
    const modalBody = document.querySelector(
      '#newReviewFormModal .yotpo-new-review-modal-body, #newReviewFormModal form'
    );
    if (!modalBody) return;

    modalBody.style.setProperty('display', 'grid', 'important');
    modalBody.style.setProperty('grid-template-columns', '100%', 'important');

    modalBody.style.setProperty('grid-template-areas', `
      "required-fields"
      "stars"
      "headline"
      "content"
      "media"
      "name"
      "email"
      "custom-questions"
    `, 'important');

    const setGrid = (el, area) => {
      if (!el) return;
      el.style.setProperty('grid-area', area, 'important');
    };

    // 1. * Required fields (footer에서 이동시켜온 뒤 가장 최상단에 배치)
    relocateRequiredFieldsNotice(modalBody);
    setGrid(modalBody.querySelector('.sg-required-fields-notice'), 'required-fields');

    // 2. Rate your experience (별점 영역 전체 container 타겟팅)
    setGrid(modalBody.querySelector('.yotpo-new-review-star-rating'), 'stars');

    // 3. Add a headline (리뷰 제목 입력 영역)
    setGrid(modalBody.querySelector('.yotpo-new-review-headline'), 'headline');

    // 4. Write a review (리뷰 내용 입력 영역)
    setGrid(modalBody.querySelector('.yotpo-new-review-content'), 'content');

    // 5. Add media (사진 업로드 영역만 단독 분리 타겟팅)
    // 실제 DOM에서는 form의 직속 자식이 .yotpo-file-upload-container (fieldset) 임
    setGrid(modalBody.querySelector('.yotpo-file-upload-container'), 'media');

    // 6. Your name
    const nameInput = modalBody.querySelector('input[id*="name"], .yotpo-input-name, input[name*="name"]');
    if (nameInput) {
      const wrap = nameInput.closest('.yotpo-input-wrapper') || nameInput;
      setGrid(wrap, 'name');
      if (!nameInput.getAttribute('placeholder')) nameInput.setAttribute('placeholder', 'your name');
    }

    // 7. Your email address
    const emailInput = modalBody.querySelector('input[id*="email"], .yotpo-input-email, input[name*="email"]');
    if (emailInput) {
      const wrap = emailInput.closest('.yotpo-input-wrapper') || emailInput;
      setGrid(wrap, 'email');
      if (!emailInput.getAttribute('placeholder')) emailInput.setAttribute('placeholder', 'abc@gmail.com');
    }

    // 8. Custom questions (피부 타입, 고민 등 문항 전체 묶음)
    // 실제 DOM에서는 form의 직속 자식이 .yotpo-custom-questions-container 임
    setGrid(modalBody.querySelector('.yotpo-custom-questions-container'), 'custom-questions');

    // 불필요한 기본 구분선 제거 (hr이 2개 이상이므로 전부 제거)
    modalBody.querySelectorAll('.yotpo-separator').forEach((sep) => {
      sep.style.setProperty('display', 'none', 'important');
    });

    modalBody.__sgGridApplied = true;
    applySubmitButtonState();
  }

  /* ─────────────────────────────────────────
   * 5. 입력 이벤트 위임
   * ───────────────────────────────────────── */
  function attachInputListeners() {
    const modal = document.querySelector('#newReviewFormModal');
    if (!modal || modal.__sgListenersAttached) return;

    modal.addEventListener('input', applySubmitButtonState);
    modal.addEventListener('change', applySubmitButtonState);
    modal.addEventListener('click', applySubmitButtonState);
    modal.__sgListenersAttached = true;
  }

  /* ─────────────────────────────────────────
   * 6. MutationObserver
   * ───────────────────────────────────────── */
  if (typeof window.__sgYotpoGridObserver === 'undefined') {
    window.__sgYotpoGridObserver = new MutationObserver((mutations) => {
      const hasAddedNodes = mutations.some(m => m.addedNodes.length > 0);
      if (!hasAddedNodes) return;

      applyYotpoGridFix();
      attachInputListeners();
    });

    window.__sgYotpoGridObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  applyYotpoGridFix();
  attachInputListeners();

})();